import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValueList } from '../../../../Fct/generics';
export var SwapOnUniswapV2Fork = createPlugin({
    protocol: 'PARASWAP',
    type: 'ACTION',
    method: 'swapOnUniswapV2Fork',
    supportedContracts: [{ address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57', chainId: 1 }],
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'paraswap_swapper_v5' }),
            value: new FctValue({ destination: 'wei_amount' }),
            methodParams: {
                tokenIn: new FctAddress({ destination: 'erc20' }),
                amountIn: new FctValue({ destination: 'wei_amount' }),
                amountOutMin: new FctValue({ destination: 'wei_amount' }),
                weth: new FctAddress({}),
                pools: new FctValueList({}),
            },
        },
        output: {},
    }); },
    initParams: {},
    requiredApprovals: function (params) {
        var _a = params.methodParams, tokenIn = _a.tokenIn, amountIn = _a.amountIn;
        return [
            {
                to: tokenIn.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: amountIn.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
